/** Up/down arrow pair used by sort toggles. */
const SortArrowsSvg = ({ color = '#006CDD' }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15.0003 3.3335L15.0002 14.3098L17.155 12.155L18.3335 13.3335L14.1668 17.5002L10 13.3335L11.1785 12.155L13.3335 14.3098L13.3337 3.3335H15.0003Z"
                fill={color}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.83447 2.5L10.0012 6.6667L8.82272 7.84523L6.66783 5.69034L6.66787 16.6667H5.0012L5.00116 5.69042L2.8465 7.84518L1.66797 6.6667L5.83447 2.5Z"
                fill={color}
            />
        </svg>
    );
};

export default SortArrowsSvg;
